import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/LayoutTop';
import Login from './pages/Login';
import DefinirClave from './pages/DefinirClave';
import SsoLanding from './pages/SsoLanding';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Cotizaciones from './pages/Cotizaciones';
import Proyectos from './pages/Proyectos';
import OrdenesTrabajo from './pages/OrdenesTrabajo';
import Mantenimiento from './pages/Mantenimiento';
import Taller from './pages/Taller';
import DetalleOrdenTaller from './pages/DetalleOrdenTaller';
import Vehiculos from './pages/Vehiculos';
import RecordatoriosTaller from './pages/RecordatoriosTaller';
import Compras from './pages/Compras';
import Facturacion from './pages/Facturacion';
import FacturasRecibidas from './pages/FacturasRecibidas';
import Reportes from './pages/Reportes';
import DetalleProyecto from './pages/DetalleProyecto';
import DetalleCotizacion from './pages/DetalleCotizacion';
import Remisiones from './pages/Remisiones';
import CuentasCobrar from './pages/CuentasCobrar';
import Configuracion from './pages/Configuracion';
import Sucursales from './pages/Sucursales';
import ImpuestosMonedas from './pages/ImpuestosMonedas';
import Aprobaciones from './pages/Aprobaciones';
import FacturasRecurrentes from './pages/FacturasRecurrentes';
import Inventario from './pages/Inventario';
import AlertasPrecio from './pages/AlertasPrecio';
import PuntoVenta from './pages/PuntoVenta';
import ReportePos from './pages/ReportePos';
import PosConfig from './pages/PosConfig';
import FormasPago from './pages/FormasPago';
import Integraciones from './pages/Integraciones';
import ImportarSiigo from './pages/ImportarSiigo';
import Productos from './pages/Productos';
import ClienteDetalle from './pages/ClienteDetalle';
import SuperAdmin from './pages/SuperAdmin';
import DetalleFactura from './pages/DetalleFactura';
import PropuestaPublica from './pages/PropuestaPublica';
import FacturaRadianPublica from './pages/FacturaRadianPublica';
import EstadoCuentaPublica from './pages/EstadoCuentaPublica';
import RegisterTenant from './pages/RegisterTenant';
import RegisterContador from './pages/RegisterContador';
import ContadorAcceso from './pages/ContadorAcceso';
import PlanCuentas from './pages/PlanCuentas';
import Comprobantes from './pages/Comprobantes';
import ConfiguracionContable from './pages/ConfiguracionContable';
import LibrosContables from './pages/LibrosContables';
import EstadosFinancieros from './pages/EstadosFinancieros';
import CierrePeriodo from './pages/CierrePeriodo';
import InformacionExogena from './pages/InformacionExogena';
import Impuestos from './pages/Impuestos';
import CertificadosRetencion from './pages/CertificadosRetencion';
import ReportesRetenciones from './pages/ReportesRetenciones';
import Empleados from './pages/Empleados';
import Nomina from './pages/Nomina';
import RecursosHumanos from './pages/RecursosHumanos';
import Gastos from './pages/Gastos';
import Usuarios from './pages/Usuarios';
import Perfiles from './pages/Perfiles';
import SgsstDashboard from './pages/SgsstDashboard';
import SgsstRiesgos from './pages/SgsstRiesgos';
import SgsstEventos from './pages/SgsstEventos';
import SgsstInspecciones from './pages/SgsstInspecciones';
import SgsstCondiciones from './pages/SgsstCondiciones';
import SgsstCapacitaciones from './pages/SgsstCapacitaciones';
import SgsstEpp from './pages/SgsstEpp';
import SgsstSalud from './pages/SgsstSalud';
import SgsstCumplimiento from './pages/SgsstCumplimiento';
import SgsstAutoevaluacion from './pages/SgsstAutoevaluacion';
import SgsstPlan from './pages/SgsstPlan';
import SgsstMatrizLegal from './pages/SgsstMatrizLegal';
import SgsstPermisos from './pages/SgsstPermisos';
import SgsstBrigadas from './pages/SgsstBrigadas';
import SgsstPresupuesto from './pages/SgsstPresupuesto';
import CmsWeb from './pages/CmsWeb';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Rutas públicas — sin autenticación */}
          <Route path="/propuesta/:token"         element={<PropuestaPublica />} />
          <Route path="/factura-electronica/:token" element={<FacturaRadianPublica />} />
          <Route path="/estado-cuenta/:token"     element={<EstadoCuentaPublica />} />
          <Route path="/login" element={<Login />} />
          <Route path="/definir-clave" element={<DefinirClave />} />
          <Route path="/sso" element={<SsoLanding />} />
          <Route path="/register" element={<RegisterTenant />} />
          <Route path="/register-contador" element={<RegisterContador />} />
          <Route path="/dashboard"       element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/clientes"        element={<ProtectedRoute><Clientes /></ProtectedRoute>} />
          <Route path="/cotizaciones"    element={<ProtectedRoute><Cotizaciones /></ProtectedRoute>} />
          <Route path="/productos"       element={<ProtectedRoute><Productos /></ProtectedRoute>} />
          <Route path="/clientes/:id"    element={<ProtectedRoute><ClienteDetalle /></ProtectedRoute>} />
          <Route path="/proyectos"           element={<ProtectedRoute><Proyectos /></ProtectedRoute>} />
          <Route path="/proyectos/:id"       element={<ProtectedRoute><DetalleProyecto /></ProtectedRoute>} />
          <Route path="/cotizaciones/:id"    element={<ProtectedRoute><DetalleCotizacion /></ProtectedRoute>} />
          <Route path="/ordenes-trabajo"     element={<ProtectedRoute><OrdenesTrabajo /></ProtectedRoute>} />
          <Route path="/mantenimientos"      element={<ProtectedRoute><Mantenimiento /></ProtectedRoute>} />
          <Route path="/taller"               element={<ProtectedRoute><Taller /></ProtectedRoute>} />
          <Route path="/taller/vehiculos"     element={<ProtectedRoute><Vehiculos /></ProtectedRoute>} />
          <Route path="/taller/recordatorios" element={<ProtectedRoute><RecordatoriosTaller /></ProtectedRoute>} />
          <Route path="/taller/:id"           element={<ProtectedRoute><DetalleOrdenTaller /></ProtectedRoute>} />
          <Route path="/compras"             element={<ProtectedRoute><Compras /></ProtectedRoute>} />
          <Route path="/facturacion"                  element={<ProtectedRoute><Facturacion /></ProtectedRoute>} />
          <Route path="/facturas-recibidas"           element={<ProtectedRoute><FacturasRecibidas /></ProtectedRoute>} />
          <Route path="/facturacion/:id"            element={<ProtectedRoute><DetalleFactura /></ProtectedRoute>} />
          <Route path="/remisiones"          element={<ProtectedRoute><Remisiones /></ProtectedRoute>} />
          <Route path="/cuentas-cobrar"      element={<ProtectedRoute><CuentasCobrar /></ProtectedRoute>} />
          <Route path="/reportes"            element={<ProtectedRoute><Reportes /></ProtectedRoute>} />
          <Route path="/contabilidad/puc"            element={<ProtectedRoute><PlanCuentas /></ProtectedRoute>} />
          <Route path="/contabilidad/comprobantes"   element={<ProtectedRoute><Comprobantes /></ProtectedRoute>} />
          <Route path="/contabilidad/configuracion"  element={<ProtectedRoute><ConfiguracionContable /></ProtectedRoute>} />
          <Route path="/contabilidad/libros"         element={<ProtectedRoute><LibrosContables /></ProtectedRoute>} />
          <Route path="/contabilidad/estados"        element={<ProtectedRoute><EstadosFinancieros /></ProtectedRoute>} />
          <Route path="/contabilidad/cierres"        element={<ProtectedRoute><CierrePeriodo /></ProtectedRoute>} />
          <Route path="/contabilidad/exogena"        element={<ProtectedRoute><InformacionExogena /></ProtectedRoute>} />
          <Route path="/contabilidad/impuestos"      element={<ProtectedRoute><Impuestos /></ProtectedRoute>} />
          <Route path="/retenciones/certificados"    element={<ProtectedRoute><CertificadosRetencion /></ProtectedRoute>} />
          <Route path="/retenciones/reportes"        element={<ProtectedRoute><ReportesRetenciones /></ProtectedRoute>} />
          <Route path="/nomina/empleados"            element={<ProtectedRoute><Empleados /></ProtectedRoute>} />
          <Route path="/nomina/periodos"             element={<ProtectedRoute><Nomina /></ProtectedRoute>} />
          <Route path="/rh"                          element={<ProtectedRoute><RecursosHumanos /></ProtectedRoute>} />
          <Route path="/gastos"                      element={<ProtectedRoute><Gastos /></ProtectedRoute>} />
          <Route path="/sgsst"                       element={<ProtectedRoute><SgsstDashboard /></ProtectedRoute>} />
          <Route path="/sgsst/riesgos"               element={<ProtectedRoute><SgsstRiesgos /></ProtectedRoute>} />
          <Route path="/sgsst/eventos"               element={<ProtectedRoute><SgsstEventos /></ProtectedRoute>} />
          <Route path="/sgsst/inspecciones"          element={<ProtectedRoute><SgsstInspecciones /></ProtectedRoute>} />
          <Route path="/sgsst/condiciones"           element={<ProtectedRoute><SgsstCondiciones /></ProtectedRoute>} />
          <Route path="/sgsst/capacitaciones"        element={<ProtectedRoute><SgsstCapacitaciones /></ProtectedRoute>} />
          <Route path="/sgsst/epp"                   element={<ProtectedRoute><SgsstEpp /></ProtectedRoute>} />
          <Route path="/sgsst/salud"                 element={<ProtectedRoute><SgsstSalud /></ProtectedRoute>} />
          <Route path="/sgsst/cumplimiento"                    element={<ProtectedRoute><SgsstCumplimiento /></ProtectedRoute>} />
          <Route path="/sgsst/cumplimiento/autoevaluacion"     element={<ProtectedRoute><SgsstAutoevaluacion /></ProtectedRoute>} />
          <Route path="/sgsst/cumplimiento/plan"               element={<ProtectedRoute><SgsstPlan /></ProtectedRoute>} />
          <Route path="/sgsst/cumplimiento/matriz-legal"       element={<ProtectedRoute><SgsstMatrizLegal /></ProtectedRoute>} />
          <Route path="/sgsst/cumplimiento/permisos"           element={<ProtectedRoute><SgsstPermisos /></ProtectedRoute>} />
          <Route path="/sgsst/cumplimiento/brigadas"           element={<ProtectedRoute><SgsstBrigadas /></ProtectedRoute>} />
          <Route path="/sgsst/cumplimiento/presupuesto"        element={<ProtectedRoute><SgsstPresupuesto /></ProtectedRoute>} />
          <Route path="/usuarios"            element={<ProtectedRoute><Usuarios /></ProtectedRoute>} />
          <Route path="/perfiles"            element={<ProtectedRoute><Perfiles /></ProtectedRoute>} />
          <Route path="/configuracion"       element={<ProtectedRoute><Configuracion /></ProtectedRoute>} />
          <Route path="/contador-acceso"     element={<ProtectedRoute><ContadorAcceso /></ProtectedRoute>} />
          <Route path="/sucursales"          element={<ProtectedRoute><Sucursales /></ProtectedRoute>} />
          <Route path="/impuestos-monedas"   element={<ProtectedRoute><ImpuestosMonedas /></ProtectedRoute>} />
          <Route path="/aprobaciones"        element={<ProtectedRoute><Aprobaciones /></ProtectedRoute>} />
          <Route path="/parametros-generales" element={<Navigate to="/configuracion" replace />} />
          <Route path="/facturas-recurrentes" element={<ProtectedRoute><FacturasRecurrentes /></ProtectedRoute>} />
          <Route path="/inventario"          element={<ProtectedRoute><Inventario /></ProtectedRoute>} />
          <Route path="/alertas-precio"      element={<ProtectedRoute><AlertasPrecio /></ProtectedRoute>} />
          <Route path="/pos"                 element={<ProtectedRoute><PuntoVenta /></ProtectedRoute>} />
          <Route path="/pos/reporte"         element={<ProtectedRoute><ReportePos /></ProtectedRoute>} />
          <Route path="/pos/config"          element={<ProtectedRoute><PosConfig /></ProtectedRoute>} />
          <Route path="/pos/formas"          element={<ProtectedRoute><FormasPago /></ProtectedRoute>} />
          <Route path="/integraciones"       element={<ProtectedRoute><Integraciones /></ProtectedRoute>} />
          <Route path="/cms-web"             element={<ProtectedRoute><CmsWeb /></ProtectedRoute>} />
          <Route path="/importar/siigo"      element={<ProtectedRoute><ImportarSiigo /></ProtectedRoute>} />
          <Route path="/super-admin"         element={<ProtectedRoute><SuperAdmin /></ProtectedRoute>} />
          <Route path="*"                element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
